import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domClass from 'dojo/dom-class';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './OccurrenceFilters.html?raw';
// Template-only widgets (used via data-dojo-type in OccurrenceFilters.html, not as values in code) → bare imports so tsc keeps them in the bundle.
import "../../../moreCore/UI/EntityBased/EntitySelect/EntitySelect";
import "../../../moreCore/UI/Multiselect/Multiselect";
// NOTE (JS2TS): dropped dead dojo deps (dom-construct, dom-attr, dom-style) — not used in code.

class OccurrenceFilters extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    home: any = null;
    filtermode: any = null;//"OccurrenceEdit",
    _searchTimeout: any = null;
    _submitInProgess = false;
    _request: any = null;
    _filterSettingsRequest: any = null;
    _filterresult: any = null;
    _filterParams: any = null;
    _lastRequestParameters: any = null;

    _startupState = "new";
    _startupSteps: any = [];
    _startupStepsDone: any = [];

    employee: any = null;
    isLdapSubstitution = false;
    isExternalEmployee = false;
    isEditor = false;
    presetBuildings: any = [];
    allFilterBuildings: any = [];
    // isEditor: false,

    startup(home?: any): void {
        super.startup.apply(this, arguments as any);
        this.home = home;

        //console.log("Filter startup, FilterHome", home);

        this.inputEmployeeGroupMulti.on("listValuesLoaded", lang.hitch(this, this._onEmployeeGroupsLoaded));
        this.inputMaintypeMulti.on("listValuesLoaded", lang.hitch(this, this._onMainTypesLoaded));
        this.inputMultiBuilding.on("listValuesLoaded", lang.hitch(this, this._onBuildingsLoaded));
        this.inputOccurrenceStatusMulti.on("listValuesLoaded", lang.hitch(this, this._onOccurrenceStatusLoaded));

        on(this, "dataLoaded", lang.hitch(this, this.home._onFilterDataLoaded)); // -> Applyfilters
    }

    setup(employee: any): void {

        this.emit("setup");
        this.disableNode(this.sectionCatalogs);
        this.employee = employee;

        let ldapSubstition = (window as any).occurrenceSubstitution;
        this.isLdapSubstitution = this.employee?.ID == ldapSubstition?.ID;

        let bIsEditor = false;

        this.isExternalEmployee = this.employee?.Classname == "Contact_person";
        let filtermode = this.filtermode ? this.filtermode : "default";
        for (var i = 0; i < this.employee.groupList.length; i++) {
            var group = this.employee.groupList[i];
            if (group.is_occurrence_group == true) {
                bIsEditor = true;
                filtermode = this.filtermode ? this.filtermode : "Editor";
                break;
            }
        }
        this.isEditor = bIsEditor;

        if (!this.isEditor) filtermode = "default";

        if (this._startupState == "ready") {
            // falls es schon mal geladen war, dann die Eingaben vorher mal ausleeren
            this.inputOccurrenceStatusMulti._setValueAttr([], true);
            this.inputMaintypeMulti._setValueAttr([], true);
            this.inputEmployeeGroupMulti._setValueAttr([], true);
            this.inputMultiBuilding._setValueAttr([]);
        }

        this._startupStepsDone = [];
        this._startupSteps = [];


        switch (filtermode) {
            case "Editor":
            case "OccurrenceEdit":
                this.filtermode = "OccurrenceEdit";
                break;
            case "default":
            case "MyOccurrences":
                this.filtermode = "default";
                break;

            //case "Region":
            //    // gibts nicht mehr...
            //    break;

            default: alert("invalid filter mode " + filtermode);
                return;
                break;
        }


        switch (this.filtermode) {
            case "default":
                this._startupSteps = ["status", "building", "maintype"];
                break;

            case "OccurrenceEdit":
                this._startupSteps = ["status", "building", "maintype"];

                if (!this.isExternalEmployee) {
                    this._startupSteps.push("employeeGroup")
                }
                break;
        }

        this.setFilterVisibility();

        this._loadFilterSettings();
    }



    _loadFilterSettings(): void {

        let filtermodeforPit = this.filtermode;
        if (this.filtermode == "MyOccurrences") {
            filtermodeforPit = "default";
        }
        else if (this.filtermode == "Editor") {
            filtermodeforPit = "OccurrenceEdit";
        }
        //else if (this.filtermode == "Region") {
        //    filtermodeforPit = "Region";
        //}

        this._startupState = "loading";

        var url = window.appRoot + "Occurrence/LoadFilterSettingsJSON";
        var jsonData: any = {};

        jsonData = {
            "filterMode": filtermodeforPit,
            "ldapsubstitution": (window as any).occurrenceSubstitution,
            //"employeeLocation": this.inputLocation.get("value")
        };

        this._filterSettingsRequest = this.RequestManager.callfunction(
            "Webtool_Occurrence_API__GetFilterSelectionJSON",
            jsonData,
            lang.hitch(this, this._onLoadFilterSettingsResponse),
            lang.hitch(this, this._onLoadFilterSettingsError)
        );


    }

    _onLoadFilterSettingsResponse(response: any): void {
        //console.log("003 _onLoadFilterSettingsResponse", response);

        this._filterSettingsRequest = null;


        this.setInputPresets(response);
        //   this.tryfilterSetup();
    }

    _onLoadFilterSettingsError(error: any): void {
        //console.log("003 ERROR _onLoadFilterSettingsResponse", error);
        this._filterSettingsRequest = null;

        this.setInputPresets(null);
    }

    setInputPresets(preset: any): void {
        this.disableNode(this.sectionCatalogs, false);
        this.filterPresets = preset;
        if (this.isExternalEmployee == true) {
            if (preset?.limitToMyExecutions === true || preset?.limitToMyExecutions === false) {
                this.inputLimitToMyExecutions.checked = preset.limitToMyExecutions == true;
            }
        }

        if (preset?.buildings) {
            //this.inputMultiBuilding.set("value", preset.buildings);
            this._reloadBuildingList(preset.buildings);
        } else {
            this._reloadBuildingList(true);
        }
        if (preset?.presetBuildings) {
            //this.inputMultiBuilding.set("value", preset.buildings);
            this.presetBuildings = preset.presetBuildings;
        } else {
            this.presetBuildings = [];
        }

        if (preset?.employeeGroups) {
            //this.inputEmployeeGroupMulti.set("value", preset.employeeGroups);
            this._reloadEmployeeGroups(preset.employeeGroups);
        } else {
            this._reloadEmployeeGroups(true);
        }

        if (preset?.occurrenceStatusList) {
            //this.inputOccurrenceStatusMulti.set("value", preset.occurrenceStatusList);
            this._reloadOccurrenceStatusList(preset.occurrenceStatusList);
        } else {
            this._reloadOccurrenceStatusList(true);
        }

        if (preset?.maintypesList) {
            //this.inputOccurrenceStatusMulti.set("value", preset.occurrenceStatusList);
            this._reloadMaintypes(preset.maintypesList);
        } else {
            this._reloadMaintypes(true);
        }


        this.pushStep("filterpreset");
        this.pushStep("limitToMyExecutions");
        this.pushStep("showAdditionalOccurrences");
    }

    setFilterVisibility(): void {

        let selectedClasses = "accentBG noInteraction";
        let deselectedClasses = "brightTransparentBG hoverBright";

        domClass.add(this.groupEmployeeGroup, "w3-hide");
        domClass.add(this.groupStatus, "w3-hide");
        domClass.add(this.groupBuilding, "w3-hide");
        domClass.add(this.containerLimitToLocation, "w3-hide");
        domClass.add(this.containerLimitToMyExecutions, "w3-hide");

        this.hideNode(this.btnFilterEditor, !this.isEditor);
        this.hideNode(this.sectionFiltermode, !this.isEditor);

        this.hideNode(this.opt_complete_by_asc, this.filtermode != "OccurrenceEdit");
        this.hideNode(this.opt_complete_by_desc, this.filtermode != "OccurrenceEdit");

        domClass.toggle(this.btnFilterEditor, selectedClasses, this.filtermode == "OccurrenceEdit");
        domClass.toggle(this.btnFilterEditor, deselectedClasses, this.filtermode != "OccurrenceEdit");

        domClass.toggle(this.btnFilterMyOccurrences, selectedClasses, this.filtermode == "default");
        domClass.toggle(this.btnFilterMyOccurrences, deselectedClasses, this.filtermode != "default");

        domClass.toggle(this.btnFilterRegion, selectedClasses, this.filtermode == "Region");
        domClass.toggle(this.btnFilterRegion, deselectedClasses, this.filtermode != "Region");



        var bShowLimitToLocation = false;
        var bShowEmployeGroups = false;
        var bShowMainTypes = true;
        var bShowStatus = true;
        var bShowLimitToMyExecutions = false;
        var bShowAdditionalOccurrences = false;
        var bShowBuilding = true;

        switch (this.filtermode) {
            case "default":
                //bShowLimitToLocation = false;
                bShowEmployeGroups = false;
                bShowAdditionalOccurrences = true;
                break;

            case "Region":
                bShowLimitToLocation = false;
                bShowEmployeGroups = false;
                bShowStatus = true;
                bShowMainTypes = true;

                break;

            case "OccurrenceEdit":

                if (this.isExternalEmployee == true) {
                    bShowLimitToMyExecutions = true;// doch fix lassen
                    bShowMainTypes = false;
                } else {
                    bShowEmployeGroups = true;
                }



                break;
        }

        domClass.toggle(this.groupMainType, "w3-hide", !bShowMainTypes);
        domClass.toggle(this.groupStatus, "w3-hide", !bShowStatus);
        domClass.toggle(this.groupBuilding, "w3-hide", !bShowBuilding);
        domClass.toggle(this.groupEmployeeGroup, "w3-hide", !bShowEmployeGroups);
        domClass.toggle(this.containerShowAdditionalOccurrences, "w3-hide", !bShowAdditionalOccurrences);
        domClass.toggle(this.containerLimitToMyExecutions, "w3-hide", !bShowLimitToMyExecutions);
        domClass.toggle(this.containerLimitToLocation, "w3-hide", !bShowLimitToLocation);

        if (this._startupState != "ready") {
            //this.inputLimitToLocation.checked = "checked";
        }
    }


    _changeEmitHandle: any = null;
    _pushStepHandle: any = null;
    pushStep(stepName: any, delay?: any): void {

        if (this._pushStepHandle) {
            clearTimeout(this._pushStepHandle);
            this._pushStepHandle = null;
        }

        //console.debug("filter push step: " + stepName, "needed/done:", this._startupSteps, this._startupStepsDone, this._startupState);

        if (this._startupStepsDone.indexOf(stepName) == -1) {
            this._startupStepsDone.push(stepName);
        }

        if (!delay) delay = 100;
        this._pushStepHandle = setTimeout(lang.hitch(this, this._afterPushStep), delay);
    }

    _afterPushStep(stepName?: any): void {
        if (this._changeEmitHandle) {
            clearTimeout(this._changeEmitHandle);
            this._changeEmitHandle = null;
        }


        let bAbort = false;
        for (var i = 0; i < this._startupSteps.length; i++) {
            var key = this._startupSteps[i];

            if (this._startupStepsDone.indexOf(key) == -1) {
                //console.log("filter: abort - not all steps done", key);
                bAbort = true;
            }
        }

        if (bAbort === true) return;

        if (this._startupStepsDone.length < this._startupSteps.length) {
            //console.debug("filter: abort - not all steps done (check2)");
            return;
        }

        if (this._startupSteps.length == 0) {
            //console.debug("filter: abort - no steps defined");
            return;
        }

        this._startupState = "ready";

        this._changeEmitHandle = setTimeout(lang.hitch(this, this.emit, "changed"), 100);
    }

    getFilterValues(): void {
        this._getSerializedFilterParams();
    }

    getAllBuildings(): any {
        let selectedValues = this.inputMultiBuilding.get("value");

        if (!selectedValues?.length) {
            return this.presetBuildings;
        }

        let allBuildings = lang.clone(this.presetBuildings);

        // null-Werte rauswerfen falls vorhanden!
        let nullIndex = allBuildings.indexOf(null);
        while (nullIndex != -1) {
            allBuildings.splice(nullIndex, 1);
            nullIndex = allBuildings.indexOf(null);
        }

        for (let bId of selectedValues) {
            if (this.presetBuildings.indexOf(bId) == -1) {
                allBuildings.push(bId);
            }
        }
        return allBuildings;

    }

    _getSerializedFilterParams(): any {

        let filterData: any = {
            employeeGroups: this.inputEmployeeGroupMulti.get("value"),
            //occurrenceStatus: this.inputOccurrenceStatusMulti.get("value")[0],
            occurrenceStatusList: this.inputOccurrenceStatusMulti.get("value"),
            //building: this.inputMultiBuilding.get("value")[0],
            buildings: this.inputMultiBuilding.get("value"),
            presetBuildings: this.getAllBuildings(),
            limitToRealEstate: this.inputLimitToLocation.checked == true,
            limitToMyExecutions: this.inputLimitToMyExecutions.checked == true,
            maintypesList: this.inputMaintypeMulti.get("value"),
            ldapsubstitution: (window as any).occurrenceSubstitution
        };

        if (this.filtermode == "default") {
            filterData.showAdditionalOccurrences = this.inputShowAdditionalOccurrences.checked == true;
        }


        filterData.sorting = this.inputSorting.value;
        filterData.searchKey = this.inputSearch.value;


        return filterData;
    }

    _reloadOccurrenceStatusList(presetStatuslist: any): void {
        if (presetStatuslist) {
            if (presetStatuslist.length == 0) {
                presetStatuslist = true; // ALLES selektieren
            }
        }

        let currentValues = null;
        try {
            currentValues = this.inputOccurrenceStatusMulti.get("value");

        } catch (ex) {

        }

        this.inputOccurrenceStatusMulti._loadListValues(presetStatuslist);


        //    // es kann passieren, dass sich das Input neu lädt, aber seine Werte gleich geblieben sind. dann passiert kein change-Event
        //    // und das Filterwidget hängt fest
        //    if (JSON.stringify(presetStatuslist) == JSON.stringify(currentValues)) {
        //        this.pushStep("status");
        //    }
    }
    _reloadMaintypes(preset: any): void {
        if (preset) {
            if (preset.length == 0) {
                preset = true; // ALLES selektieren
            }
        }
        this.inputMaintypeMulti._loadListValues(preset);
    }

    _reloadEmployeeGroups(preset: any): void {
        if (preset) {
            if (preset.length == 0) {
                preset = true; // ALLES selektieren
            }
        }
        this.inputEmployeeGroupMulti._loadListValues(preset);
    }

    _reloadBuildingList(BuildingsFromInput?: any): void {
        /*  for (i = 0; i < BuildingsFromInput.length; i++)
              if (this.presetBuildings.indexOf(BuildingsFromInput[i]) == -1)
                  this.presetBuildings.push(BuildingsFromInput[i]); */
        // this.presetBuildings = presetBuildings;
        var jsonData: any = {};

        if (this.home.employee == null) {
            jsonData = { "limitToRealEstate": false };
        }
        else {
            jsonData = {
                "limitToRealEstate": this.inputLimitToLocation.checked == true, "employee": { "ID": this.home.employee.ID }
            };
        }
        //console.log("reload Buildinglist", jsonData, this._startupStepsDone);

        var label = this.translations["General_DropdownBlank_All_FromX"];
        if (jsonData.limitToRealEstate != true) {
            label = this.translations["General_DropdownBlank_All"];
        }
        //this.inputBuilding.setRequestParameter("jsonData", JSON.stringify(jsonData));
        //this.inputBuilding.set("blankOption", true, null, label.format(this.employee.ref_last_location.tmp_label));
        //this.inputBuilding._loadListValues(presetBuilding);

        this.inputMultiBuilding.setRequestParameter("jsonData", JSON.stringify(jsonData));
        this.inputMultiBuilding._loadListValues(null);

    }



    _onChangeOccurrenceStatusMulti(selectedValue?: any): void {

        //console.debug("_onChangeOccurrenceStatusMulti", selectedValue);
        this.pushStep("status");

    }

    _onChangeLimitToMyExecutions(selectedValue?: any): void {

        //console.debug("_onChangeBuilding", selectedValue);
        this.pushStep("limitToMyExecutions");

    }

    _onChangeShowAdditionalOccurrences(selectedValue?: any): void {
        this.pushStep("showAdditionalOccurrences");
    }



    _onChangeBuildingMulti(value?: any): void {
        //console.debug("_onChangeBuildingMulti", value);
        this.pushStep("building");

    }


    _onChangeEmployeegroupMulti(selectedValue?: any): void {

        //console.debug("_onChangeEmployeegroupMulti", selectedValue);
        this.pushStep("employeeGroup");
    }
    _onChangeMaintypeMulti(selectedValue?: any): void {

        //console.debug("_onChangeMaintypeMulti", selectedValue);
        this.pushStep("maintype");
    }

    _onChangeLimitToLocation(evt?: any): void {
        //var newPreset = this.inputLimitToLocation.checked == true ?
        this._reloadBuildingList(this.inputMultiBuilding.get("value"));

    }



    _onChangeSorting(evt?: any): void {
        this.pushStep("sorting");
    }

    _onChangeSearch(evt: any): void {

        this.pushStep("searchkey", !this.inputSearch.value || evt.code == "Enter" || evt.key == "Enter" ? 20 : 1500);
    }

    _onClick_Btn_FilterEditor(evt?: any): void {
        this.filtermode = "Editor";
        this.setup(this.employee);
    }

    _onClick_Btn_FilterMyOccurrences(evt?: any): void {
        this.filtermode = "default";
        this.setup(this.employee);
    }

    _onClick_Btn_FilterRegion(evt?: any): void {

    }


    _onEmployeeGroupsLoaded(): void {

    }

    _onMainTypesLoaded(): void {

    }

    _onBuildingsLoaded(): void {
        let allBuildings = lang.clone(this.presetBuildings);

        // erst mal null-Werte rauslöschen
        let nullIndex = allBuildings.indexOf(null);
        while (nullIndex != -1) {
            allBuildings.splice(nullIndex, 1);
            nullIndex = allBuildings.indexOf(null);
        }

        this.presetBuildings = allBuildings;

        // falls garkeine Gebäude gewählt waren, dann mit true vorerst einfach alle wählen
        if (typeof (this.presetBuildings) == "undefined" || !this.presetBuildings.length) {
            this.presetBuildings = [];
            this.inputMultiBuilding._setValueAttr(true); // ALLES selektieren
        }
        else //if (this.presetBuildings)
        {

            let previouslySelected = [];
            let hiddenList = [];
            for (var i = 0; i < this.inputMultiBuilding.valueList.length; i++) {
                let availableEntry = this.inputMultiBuilding.valueList[i];

                let indexInPreset = this.presetBuildings.indexOf(availableEntry.ID)

                // war dieser Eintrag früher mal gewählt und steht deshalb im Preset?
                if (indexInPreset != -1) {
                    // in die Vorselektierung aufnehmen
                    previouslySelected.push(this.presetBuildings[indexInPreset]);

                    // ... und aus dem Preset rausschmeißen
                    this.presetBuildings.splice(indexInPreset, 1);
                }
                else {
                    hiddenList.push(availableEntry);
                }
            }

            if (previouslySelected.length == 0) {
                this.inputMultiBuilding._setValueAttr(true); // ALLES selektieren
            }
            else
                this.inputMultiBuilding._setValueAttr(previouslySelected);
        }

    }

    _onOccurrenceStatusLoaded(): void {

    }



    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.presetBuildings = [];
        this._startupStepsDone = [];
    }

}
OccurrenceFilters.prototype.declaredClass = 'WidgetCollection.Occurrence.OccurrenceFilters';

export default mdsWidget(OccurrenceFilters);
